import React, { useEffect, useState } from 'react';

export default function ResultView({ score }) {
  const [count, setCount] = useState(0);
  const passed = score >= 6;
  const [hintText, setHintText] = useState("");

  useEffect(() => {
    let current = 0;
    const duration = 1000; // 1 Sekunde
    const steps = 30;
    const increment = score / steps;

    const interval = setInterval(() => {
      current += increment;
      if (current >= score) {
        setCount(score);
        clearInterval(interval);
      } else {
        setCount(Math.floor(current));
      }
    }, duration / steps);

    return () => clearInterval(interval);
  }, [score]);

  useEffect(() => {
    const key = passed ? 'result_success' : 'result_fail';
    fetch(`https://quizapi.steilpass-fussballjobs.de/api/hints/${key}`)
      .then(res => res.json())
      .then(data => {
        const replaced = data.content.replace(/\{\{score\}\}/g, score);
        setHintText(replaced);
      })
      .catch(err => console.error('Fehler beim Laden des Result-Hints:', err));
  }, [passed, score]);

  return (
    <div
      className={`container text-center py-5 ${passed ? 'result-success' : 'result-fail'}`}
      style={{ maxWidth: '700px' }}
    >
      {/* Hint-Text aus der Datenbank */}
      <div className="text-start mt-4" dangerouslySetInnerHTML={{ __html: hintText }} />
    </div>
  );
}
